import eventBus from "./event-bus"

function register(app) {
	app.use(eventBus)
}

export default {
	register
}
